<script>
import Copyright from "../components/Copyright.svelte";
let newButtonDirection = '#forms-list'

function newButtonRedirection () {
  // Funcion para hacer que si hay un unico form se
  // entre a completar este inmediantamente al presionar en el boton "nuevo"
  let formsCount = Appl.model.formsList.count();
  if (formsCount > 1 || formsCount == 0) {
    newButtonDirection = '#forms-list';
  } else if (formsCount == 1){
    newButtonDirection = '#new-record?id=' + Appl.model.formsList._list[0].uuid;
  }
}

</script>

<!--
  La pagina Main con sus Tiles
-->
<div class="page" id="main">

  <div class="content">
    <div id="home" class="container tiled-grid">
      <div id="datagrip" class="tile">
        <!-- customized-datagrip-tile -->
      </div>

      <div id="new" class="tile nav" on:click={newButtonRedirection} href={newButtonDirection}>
        <br />
        <i class="icon ion-plus"></i>
        <br />
        <h2>Nuevo ...</h2>
        <p><span name="forms-count"></span> formularios</p>
        <div class="on-bottom">
        </div>
      </div>

      <div id="info" class="tile">
        <br />
        <i class="icon ion-information"></i>
        <br />
        <h2 class="nav" href="#info-lists">Info</h2>
        <p>Hay <span name="info-lists-count"></span> listas</p>
        <br />
        <ul class="bottom content-list"></ul>
      </div>

      <div id="pending" class="tile with-worklists">
        <br />
        <i class="icon ion-compose nav" href="#edit-list"></i>
        <br />
        <h2 class="nav" href="#edit-list">Pendientes</h2>
        <p>Hay <span name="total-pending-count"></span> en total</p>
        <br />
        <ul class="content-grid worklists">
        </ul>
        <br />
        <ul class="content-grid states no-on-bottom no-max-5-per-row">
          <li class="nav" href="#edit-list"><em name="edit-count"></em><a>Borradores </a></li>
          <li class="nav" href="#init-list"><em name="init-count"></em><a>Completar </a></li>
          <li class="nav" href="#review-list"><em name="review-count"></em><a>Revisar </a></li>
          <!--
                  <li class="nav" href="#work-list"><em name="work-count"></em><a>Worklists</a></li>
                  -->
          <li class="nav" href="#emited-list"><em name="emited-count"></em><a>Emitidos a sincronizar</a></li>
        </ul>
      </div>

      <div id="sent" class="tile" href="#">
        <br />
        <i class="icon ion-social-buffer-outline nav" href="#sent-list?days=1"></i>
        <br />
        <h2 class="nav" href="#sent-list?days=1">Historial</h2>
        <p>Ya enviados</p>
        <br />
        <ul class="content-list">
          <li class="nav" href="#search-list"><a>Buscar ...</a> <i class="icon ion-android-search"></i></li>
          <li class="nav" href="#sent-list?days=1"><a>Hoy</a></li>
          <li class="nav" href="#sent-list?days=2"><a>Ayer</a></li>
          <li class="nav" href="#sent-list?days=7"><a>Esta semana </a></li>
          <li class="nav" href="#sent-list?days=1000"><a>Más ...</a></li>
        </ul>
      </div>

      <div id="syncro" class="tile nav" href="#syncronize"> 
        <br />
        <i class="icon ion-ios7-loop-strong"></i>
        <br />
        <h2>Sincronizar</h2>
        <p>Última: <span id="last-syncro-msg"></span></p>
        <div class="on-bottom"></div>
      </div>

      <div id="me" class="tile nav" href="#session">
        <br />
        <i class="icon ion-person"></i>
        <br />
        <h2>Mi sesión</h2>
        <p id="user-full-name">Mario Aníbal Zito</p>
        <p class="on-bottom" id="user-last-login"></p>
      </div>

      <div id="logo" class="tile">
        <!-- customized-logo-tile -->
      </div>

      <Copyright />

    </div>
  </div>
</div>

<!--
  Los TILES que se customizan para una dada implementacion.
-->
<div class="invisible" id="customized-datagrip">
  <div name="logos-tile">
    <br />
    <br />
    <img class="logo" src="" />
    <br />
    <h5>Ayudamos a construir calidad.</h5>
    <p><a href="http://www.analyte.com">www.analyte.com</a></p>
    <p class="sp">
      <br />
      Luis María Drago 1951, Of. 7, Piso 1.
      <br />
      Parque Industrial de Almirante Brown (Burzaco)
      <br />
      (1852) Buenos Aires, Argentina
    </p>
    <br /><br />
  </div>

  <div name="datagrip-tile" style="margin-top: auto; margin-bottom:-auto;vertical-align:middle;">
    <img class="logo" src="img/custom/treme/logo-treme-degrade-oficial.png" />
    <br />
    <p>
      <b>Captura tu información en movimiento.</b>
    </p>
    <br />
    <p class="sp">
      www: <a class="external sp" href="https://treme.io">treme.com.ar</a>
    </p>
    <p class="sp">
      @: <a href="mailto:soporte@treme.com.ar">soporte@treme.com.ar</a>
    </p>
    <p class="sp">
      T: <a href="tel:00541152580205">(54-11) 5258-0205</a><br>
    </p>
  </div>
</div>
